import { ISegment } from '../../pages/segments-container/share-type'
import { SegmentsAction } from './action'
import { SET_FIRST_PAGE_SEGEMENTS } from './constants'
import update from 'immutability-helper'

interface InitialState {
  firstPageSegments: ISegment[]
}

const initialState: InitialState = {
  firstPageSegments: [],
}

function segmentsReducer(state = initialState, action: SegmentsAction) {
  switch (action.type) {
    case SET_FIRST_PAGE_SEGEMENTS:
      return update(state, { $merge: { firstPageSegments: action.payload } })
    default:
      return state
  }
}

export default segmentsReducer
